import {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";

import styles from "./styles/NavigationPrimary.module.scss";
import classNames from "classnames";
import {primaryNavHeight} from "../../utils/Settings";
import {StoreContext} from "../../stores/StoreLoader";
import SchoolBlocksHeader from "./SchoolBlocksHeader";
import * as React from "react";
import {useMainUrl} from "../../hooks/useMainUrl";

const NavigationPrimary = observer(props => {
    const {interfaceStore} = useContext(StoreContext);

    const visible = useMemo(() => {
        return interfaceStore.scrollPosition > primaryNavHeight;
    }, [interfaceStore.scrollPosition]);

    const mainUrl = useMainUrl();

    const containerClassName = classNames({
        [styles.schoolBlocksHeader]: true,
        [styles.schoolBlocksHeaderHeroIsEnabled]: props.heroIsEnabled,
        [styles.schoolBlocksHeaderVisible]: visible || !props.heroIsEnabled,
    });

    return (
        <div className={containerClassName}>
            <SchoolBlocksHeader mainUrl={mainUrl} hideNavigation={true} hideLoginButton={false}/>
        </div>
    );
});

NavigationPrimary.propTypes = {
    isWelcomePage: PropTypes.bool,
    heroIsEnabled: PropTypes.bool,
};

export default NavigationPrimary;
